// extracted by mini-css-extract-plugin
module.exports = {"addBtn":"CreditBox_addBtn__2YGg1","boxBtn":"CreditBox_boxBtn__3nyOY"};